import { Form, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { lowerCase } from "lodash";

import { baseUnitCreate } from "./createOrder.constants";
import { ReactComponent as DeleteIcon } from "@/assets/images/desktop/closemin.svg";

import classes from "./createOrder.module.scss";

import { decimalValidateNew, formatMiles, formatMilesDecimalNew, integerValidate } from "@/services/Utils";

import { NoOptionsMessage, SingleValue } from "@/components/ReactSelect/NoOptions";
import ProductInput from "@/components/Form/Inputs/Product/ProductInput";

const CreateOrderTableItem = ({
	data,
	setData,
	products,
	changeTextProduct,
	changeProduct,
	changeQuantity,
	changeContainerContent,
	changeUnitMeasurement,
	changePrice,
	changeTypeProduct,
}) => {
	return (
		<Table className={classes.tableDetail}>
			<thead className={classes.tableDetailHead}>
				<tr>
					<th className={classes.headTh}>
						Producto <br />
						<small>Ingrese al menos 3 letras para buscar.</small>
					</th>
					<th className={classes.headTh}>Cant. Envases</th>
					<th className={classes.headTh}>Contenido</th>
					<th className={classes.headTh}>U.M</th>
					<th className={classes.headTh}>Precio Total Neto</th>
					<th className={classes.headTh}>Observaciones</th>
					<th className={classes.headTh}></th>
				</tr>
			</thead>
			<tbody>
				{data &&
					data.items &&
					data.items.map((item, i) => {
						return (
							<tr key={i}>
								{/* Product */}
								<td
									style={{
										width: "30%",
									}}
								>
									<CreatableSelect
										value={products && products.filter((p) => p.value === item.product_id)}
										options={
											item.text_product && item.text_product.length > 1
												? products && products.filter((p) => lowerCase(p.label).includes(lowerCase(item.text_product)))
												: []
										}
										menuPortalTarget={document.body}
										components={{
											NoOptionsMessage,
											SingleValue,
											Option: ProductInput,
										}}
										formatCreateLabel={(value) => {
											return `Crear ${value}`;
										}}
										placeholder={""}
										isClearable
										onInputChange={(value) => changeTextProduct(i, value)}
										onChange={(opt, meta) => {
											changeProduct(i, opt, meta);
										}}
										menuPlacement="top"
									/>
								</td>
								{/* Quantity */}
								<td
									style={{
										display: "none",
										width: "0%",
									}}
								>
									<Form.Control
										className={classes.input}
										style={{
											textAlign: "right",
										}}
										type="text"
										value={item && item.quantity ? formatMiles(item.quantity) : ""}
										onChange={(e) => changeQuantity(i, e.target.value)}
										onKeyDown={integerValidate}
									/>
								</td>
								{/* Content */}
								<td
									style={{
										width: "15%",
									}}
								>
									<Form.Control
										className={classes.input}
										style={{
											textAlign: "right",
										}}
										type="text"
										value={item && item.container_content ? formatMilesDecimalNew(item.container_content) : ""}
										onChange={(e) => changeContainerContent(i, e.target.value)}
										onKeyDown={decimalValidateNew}
									/>
								</td>
								{/* Unit */}
								<td
									style={{
										width: "15%",
									}}
								>
									<Select
										value={
											Number(item.value_unit_measurement) && item.units_enabled
												? item.units_enabled.filter((b) => Number(b.value) === Number(item.value_unit_measurement))
												: baseUnitCreate.filter((b) => b.value === item.value_unit_measurement)
										}
										placeholder={<div></div>}
										options={item.units_enabled ? item.units_enabled : baseUnitCreate}
										onChange={(value) => changeUnitMeasurement(i, value.value)}
										menuPortalTarget={document.body}
										menuPlacement="top"
									/>
								</td>
								{/* Price Total */}
								<td
									style={{
										width: "15%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										style={{
											textAlign: "right",
										}}
										value={item && item.price_total && formatMilesDecimalNew(item.price_total)}
										onChange={(e) => changePrice(i, e.target.value)}
										onKeyDown={decimalValidateNew}
									/>
								</td>
								{/* Type Product */}
								<td
									style={{
										width: "20%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.type_product && item.type_product}
										onChange={(e) => changeTypeProduct(i, e.target.value)}
									/>
								</td>
								{/* Actions */}
								{item && (
									<td
										style={{
											width: "5%",
										}}
									>
										<OverlayTrigger overlay={<Tooltip>Eliminar Producto</Tooltip>}>
											<DeleteIcon
												className={classes.buttonClose}
												onClick={() => {
													let newItems = [...data.items];
													newItems.splice(i, 1);
													setData({
														...data,
														items: newItems,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								)}
							</tr>
						);
					})}
			</tbody>
		</Table>
	);
};

export default CreateOrderTableItem;
